// extracted by mini-css-extract-plugin
module.exports = {"baseBanner":"BaseBannerJtails_baseBanner_3Gx7l","isStyleDingBeauty":"BaseBannerJtails_isStyleDingBeauty_2Sncq"};